import { EFormFieldInputTypes } from "app/Components/Form/FormField.component";
import configureStore from "../.././../redux/Store";
import React, { Fragment, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import localStorageService from "app/services/localStorageService";
import { Col, Popover, Row } from "react-bootstrap";
import CustomPopover from "app/Components/CommanComponents/CustomPopover";
import { BsFillInfoCircleFill } from "react-icons/bs";
import CommentPopup from "app/_pages/_healthSafetyEnvironment/IncidentManagement/CommentPopup";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import {
  FORMA_ROLES,
  HO_ROLES,
  INCIDENT_ROLES,
  MEDICAL_ROLES,
  MINE_ROLES,
  moduleType,
  RO_ROLES,
  TRAINING_ROLES,
  VFL_ROLES,
} from "app/_constants/constant";
import {
  DDMMYYYYFormat,
  DDMMYYYYHHMMAFormat,
  YYYYMMDDHHMMAFormat,
} from "app/_helpers/dateHelper";
import { Validation } from "app/_helpers/validation/Validation";
import { siteTypeObj } from "app/_pages/_globalConfiguration/HealthSafetyEnvironment/Sites/Sites";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
export const userFormLabel = {
  firstName: "First Name",
  lastName: "Last Name",
  classification: "User Classification",
  comapnyId: "Organisation",
  departmentId: "Department",
  designation: "Designation",
  roleId: "Role",
  email: "Email ID",
  siteId: "Site ID",
  contactNumber: "Mobile Number",
};

export const USER_STATUS_OBJ = {
  active: "Active",
  inActive: "InActive",
};

export const userFieldRules = [
  {
    field_name: "firstName",
    label: userFormLabel.firstName,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "lastName",
    label: userFormLabel.lastName,
    type: "text",
    isRequired: true,
  },
  {
    field_name: "email",
    label: userFormLabel.email,
    type: "email",
    isRequired: true,
  },
  {
    field_name: "roleId",
    label: userFormLabel.roleId,
    type: "text",
    isRequired: true,
  },
  // {
  //   field_name: "siteId",
  //   label: userFormLabel.siteId,
  //   type: "text",
  //   isRequired: false,
  // },
  {
    field_name: "contactNumber",
    label: userFormLabel.contactNumber,
    type: "number",
    minLength: 10,
    maxLength: 10,
    isRequired: false,
  },
  // {
  //   field_name: "designation",
  //   label: userFormLabel.designation,
  //   type: "text",
  //   isRequired: true,
  // },
];

export const userValidation = (form) => {
  let errorObj = Validation(form, userFieldRules);
  return errorObj;
};

export const USER_PERMISSION = {
  ADD: "superAdmin",
};

export const checkUserLevelAccess = (user) => {
  const authUser = localStorageService.getItem("auth_user");

  if (!authUser?.user?.role?.roleLable) return false; // if loggedIn user role not exist return false
  if (!user?.role?.roleLable) return true; // if role not assigned yet , return true

  const authUserRoleLevel = authUser?.user?.role?.roleLable;
  const userRoleLevel = user?.role?.roleLable;

  // low level  user has access for higher level  users (level 1 user has access of level 2,3,4 users)
  return authUserRoleLevel < userRoleLevel ? true : false;
};

export const MeetingScheduler = [
  // { name: "Scheduler Roles", key: "SR" },
  { name: "Safety Officer", key: "safetyOfficer" },
  { name: "Mines Manager", key: "minesManager" },
  // { name: "Mines Manager - RO", key: "minesManager" },
  // { name: "HR Manager - RO", key: "hrManager" },
  { name: "HR Manager", key: "hrManager" },
  { name: "HR Head - RO", key: "hrHead" },
  { name: "Head Safety - HO", key: "headSafety" },
];

export const userTableColumn = [
  {
    dataField: "sid",
    text: "S.No.",
    sort: true,
    headerClasses: "tblSnCol",
  },
  {
    dataField: "siteLocationName",
    text: "Current Location",
    sort: true,
  },
  {
    dataField: "locationType",
    text: "Location Type",
    sort: true,
    formatter: (locationType, row) => siteTypeObj[row?.locationType] || "",
  },
  {
    dataField: "employee.employeeId",
    text: "Emp ID",
    sort: true,
  },
  // {
  //   dataField: "viewCreatedAt",
  //   text: "Reg. Date",
  //   sort: true,
  // },
  {
    dataField: "name",
    text: "Name",
    sort: true,
  },
  {
    dataField: "email",
    text: "Email",
    sort: true,
  },
  {
    dataField: "employee.mobileNumber",
    text: "Mobile",
    sort: true,
  },

  // {
  //   dataField: "department.name",
  //   text: "Department",
  //   sort: true,
  // },

  {
    dataField: "userStatus",
    text: "User Status",
    sort: true,
  },
  {
    dataField: "createdAt",
    text: "Signup date",
    sort: true,
  },
  {
    dataField: "lastResentUserMailDate",
    text: "Mail Sent Date",
    sort: true,
  },
  {
    dataField: "lastMobileEnableDate",
    text: "Mobile Enabled Date",
    sort: true,
    formatter: (signupDate, row) =>
      row?.lastMobileEnableDate
        ? DDMMYYYYHHMMAFormat(row?.lastMobileEnableDate)
        : row?.lastMobileEnableDate,
  },
];

export const userFilterFields = [
  {
    name: "siteIdEmp",
    title: "Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "locationType",
    title: "Location Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(siteTypeObj).map((k) => ({
      label: siteTypeObj[k],
      value: +k,
    })),
  },
  // {
  //   name: "classification",
  //   title: 'Classification',
  //   inputType: EFormFieldInputTypes.text,
  // },
  {
    name: "userStatus",
    title: "User Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(USER_STATUS_OBJ).map((k) => ({
      label: USER_STATUS_OBJ[k],
      value: USER_STATUS_OBJ[k],
    })),
  },
  {
    name: "roleId",
    title: "Standard Role",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  // {
  //   name: "roleId",
  //   title: 'Admin Type',
  //   inputType: EFormFieldInputTypes.searchableSelect,
  // },
  {
    name: "imRole",
    title: "IM Role",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [...INCIDENT_ROLES, ...MINE_ROLES].map((k) => ({
      label: k.label,
      value: k.name,
    })),
  },
  {
    name: "vflRole",
    title: "VFL Role",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [...VFL_ROLES, ...MINE_ROLES].map((k) => ({
      label: k.label,
      value: k.name,
    })),
  },
  {
    name: "trainingRole",
    title: "Training Role",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [...TRAINING_ROLES, ...MINE_ROLES].map((k) => ({
      label: k.label,
      value: k.name,
    })),
  },
  {
    name: "medicalRole",
    title: "Medical Role",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [...MEDICAL_ROLES, ...MINE_ROLES].map((k) => ({
      label: k.label,
      value: k.name,
    })),
  },
  {
    name: "ohseRole",
    title: "OHSE Role",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: MeetingScheduler.map((k) => ({
      label: k.name,
      value: k.key,
    })),
  },
  {
    name: "formARole",
    title: "Form A Role",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [...FORMA_ROLES, ...MINE_ROLES].map((k) => ({
      label: k.label,
      value: k.name,
    })),
  },
  // {
  //   name: "departmentName",
  //   title: "Department",
  //   inputType: EFormFieldInputTypes.searchableSelect,
  // },
  {
    name: "contactNumber",
    title: "Mobile",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "email",
    title: "Email",
    inputType: EFormFieldInputTypes.text,
  },
];

export const clearEmployeesStore = () => {
  let SET_EMPLOYEE_DATA = "SET_EMPLOYEE_DATA";
  let { Store } = configureStore();
  let updateStore = {
    data: {
      employees: [],
    },
  };

  Store.dispatch({
    type: SET_EMPLOYEE_DATA,
    data: updateStore,
  });

  Store.dispatch({
    type: USER_DATA_CONSTANT.EMPLOYEE_FOR_OTHER_MODUEL,
    data: [],
  });

  Store.dispatch({
    type: USER_DATA_CONSTANT.EMPLOYEE_IN_ACTIVE_UNASSIGNED,
    data: updateStore,
  });
  Store.dispatch({
    type: USER_DATA_CONSTANT.EMPLOYEE_IN_ACTIVE_ASSIGNED,
    data: updateStore,
  });

  // for employee status change
  Store.dispatch({
    type: USER_DATA_CONSTANT.MEDICAL_ALL,
    data: [],
  });
  Store.dispatch({
    type: USER_DATA_CONSTANT.MEDICAL_IN_ACTIVE_UNASSIGNED,
    data: [],
  });
  Store.dispatch({
    type: USER_DATA_CONSTANT.MEDICAL_IN_ACTIVE_ASSIGNED,
    data: [],
  });
  Store.dispatch({
    type: USER_DATA_CONSTANT.TRAINING_IN_ACTIVE_UNASSIGNED,
    data: [],
  });
  Store.dispatch({
    type: USER_DATA_CONSTANT.TRAINING_IN_ACTIVE_ASSIGNED,
    data: [],
  });
  Store.dispatch({
    type: USER_DATA_CONSTANT.OLD_EMPLOYEE,
    data: [],
  });
};

export const clearMyIncidentStore = () => {
  let MY_INCIDENTS = "MY_INCIDENTS";
  let { Store } = configureStore();
  let updateStore = {
    data: {
      data: [],
    },
  };

  Store.dispatch({
    type: MY_INCIDENTS,
    data: updateStore,
  });
};

export const clearContractorPersonStore = () => {
  let { Store } = configureStore();
  let updateStore = {
    data: {
      contractorPerson: {},
    },
  };
  let unAssignedStore = {
    data: {
      conPersonInActiveUnassigned: {},
    },
  };
  let assignedStore = {
    data: {
      conPersonInActiveAssigned: {},
    },
  };

  Store.dispatch({
    type: USER_DATA_CONSTANT.CONTRACTOR_PERSON,
    data: updateStore,
  });

  Store.dispatch({
    type: USER_DATA_CONSTANT.CONTRACTOR_PERSON_FOR_OTHER_MODUEL,
    data: [],
  });

  Store.dispatch({
    type: USER_DATA_CONSTANT.CONTRACTOR_PERSON_IN_ACTIVE_UNASSIGNED,
    data: unAssignedStore,
  });
  Store.dispatch({
    type: USER_DATA_CONSTANT.CONTRACTOR_PERSON_IN_ACTIVE_ASSIGNED,
    data: assignedStore,
  });

  // for employee status change
  Store.dispatch({
    type: USER_DATA_CONSTANT.MEDICAL_ALL,
    data: [],
  });
  Store.dispatch({
    type: USER_DATA_CONSTANT.MEDICAL_IN_ACTIVE_UNASSIGNED,
    data: [],
  });
  Store.dispatch({
    type: USER_DATA_CONSTANT.MEDICAL_IN_ACTIVE_ASSIGNED,
    data: [],
  });
  Store.dispatch({
    type: USER_DATA_CONSTANT.TRAINING_IN_ACTIVE_UNASSIGNED,
    data: [],
  });
  Store.dispatch({
    type: USER_DATA_CONSTANT.TRAINING_IN_ACTIVE_ASSIGNED,
    data: [],
  });
  Store.dispatch({
    type: USER_DATA_CONSTANT.OLD_CONTRACTOR_PERSON,
    data: [],
  });
};

export const clearContractorStore = () => {
  let { Store } = configureStore();

  Store.dispatch({
    type: USER_DATA_CONSTANT.CONTRACTOR_FOR_OTHER_MODUEL,
    data: [],
  });
};

export const clearStoreByModuleWise = (module) => {
  let { Store } = configureStore();

  switch (module) {
    case moduleType.ehsIncidentDetails:
      clearMyIncidentStore();
      let emptyData = { data: { data: [] } };
      Store.dispatch({
        type: USER_DATA_CONSTANT.INCIDENTS,
        data: emptyData,
      });
      break;
    case moduleType.ehs_vfls:
      Store.dispatch({
        type: USER_DATA_CONSTANT.MY_VFL,
        data: [],
      });
      Store.dispatch({
        type: USER_DATA_CONSTANT.VIEW_VFL,
        data: [],
      });
      break;
    case moduleType.ehsEventSchedule:
      Store.dispatch({
        type: USER_DATA_CONSTANT.ALL_EVENT_SCHEDULE,
        data: [],
      });
      break;
    case moduleType.ehsCapa:
      Store.dispatch({
        type: USER_DATA_CONSTANT.CAPA,
        data: [],
      });
      break;
    case moduleType.ehsTrainingAssigners:
      Store.dispatch({
        type: USER_DATA_CONSTANT.BASIC_TRAINING,
        data: [],
      });
      Store.dispatch({
        type: USER_DATA_CONSTANT.NEW_BASIC_TRAINING,
        data: [],
      });
      Store.dispatch({
        type: USER_DATA_CONSTANT.ALL_TRAINING_DATA,
        data: [],
      });
      Store.dispatch({
        type: USER_DATA_CONSTANT.TRAINING_IN_ACTIVE_UNASSIGNED,
        data: [],
      });
      Store.dispatch({
        type: USER_DATA_CONSTANT.TRAINING_IN_ACTIVE_ASSIGNED,
        data: [],
      });
      break;
    case moduleType.ehsMedicalAssigners:
      Store.dispatch({
        type: USER_DATA_CONSTANT.MEDICAL_ALL,
        data: [],
      });
      Store.dispatch({
        type: USER_DATA_CONSTANT.MEDICAL_IN_ACTIVE_UNASSIGNED,
        data: [],
      });
      Store.dispatch({
        type: USER_DATA_CONSTANT.MEDICAL_IN_ACTIVE_ASSIGNED,
        data: [],
      });
      Store.dispatch({
        type: USER_DATA_CONSTANT.MEDICAL_ALL_DONE,
        data: [],
      });
      break;
    default:
      break;
  }
};
